module.exports = __webpack_public_path__ + "static/media/diet_repo.2012f4dd.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/books/diet_repo.svg
// module id = 408
// module chunks = 0